import { useIntl } from 'react-intl'
import styled from 'styled-components'
import PriceRowTaxesAndFees from 'LuxKit/PricePoints/PriceRowTaxesAndFees'
import PriceRowPrice from 'LuxKit/PricePoints/PriceRowPrice'
import PriceRowValueDiscountWithCaption from 'LuxKit/PricePoints/Value/PriceRowValueDiscountWithCaption'
import { useOfferRatePrice } from 'hooks/Offers/useOfferPrice'
import useOfferTilePriceBlockExperiment from 'hooks/Experiments/useOfferTilePriceBlockExperiment'
import OfferTilePriceBlockCaption from 'components/OfferList/OfferListTiles/Support/OfferTilePriceBlockCaption'

const Root = styled.div`
`

interface Props {
  rate?: App.BedbankRate
  offer: App.BedbankOffer | App.BedbankOfferSummary
}

function HeroBedbankPriceDetails(props: Props) {
  const {
    rate,
    offer,
  } = props
  const intl = useIntl()
  const ratePrices = useOfferRatePrice(offer, rate)
  const hotelNights = rate?.nights ?? offer?.sell?.los
  const priceBlockVariation = useOfferTilePriceBlockExperiment(offer, true, (ratePrices?.totalPrice ?? 0) > 0)
  if (!ratePrices) {
    return null
  }

  const {
    totalPrice,
    saleUnit,
    totalValue,
    valueOffPercent,
  } = ratePrices

  return <Root>
    <OfferTilePriceBlockCaption priceBlockExperimentVariation={priceBlockVariation} duration={hotelNights} saleUnit={offer.saleUnit}>
      {intl.formatMessage(
        {
          id: 'dpgRKFB0jQfunkUf3JmP',
          defaultMessage: '{count, plural, one {# night} other {# nights}} from',
          description: 'Duration in nights followed by "from" for hero bedbank price caption',
        },
        { count: hotelNights! },
      )}
    </OfferTilePriceBlockCaption>
    <PriceRowPrice size="L" price={totalPrice} saleUnit={priceBlockVariation ? 'total' : saleUnit} />
    <PriceRowTaxesAndFees />
    {!priceBlockVariation && valueOffPercent > 0 && <PriceRowValueDiscountWithCaption
      size="M"
      originalValue={totalValue}
      discountPercentage={valueOffPercent}
    />}
  </Root>
}

export default HeroBedbankPriceDetails
